import {DateFormatProps} from "@blueprintjs/datetime";

import dayjs, {Dayjs} from "./dayjs";

export const localTimeZone = "Asia/Tokyo";

export function toJst(time: Dayjs): Dayjs {
    return time.tz(localTimeZone);
}

export function getDayFormatter(format: string): DateFormatProps {
    return {
        formatDate: (date) => dayjs(date).tz(localTimeZone).format(format),
        parseDate: (str) => dayjs.tz(str, format, localTimeZone).toDate(),
        placeholder: format,
    };
}

export const DayFormats = {
    date: "YYYY-MM-DD",
    datetimeMinute: "YYYY-MM-DD HH:mm",
};
